module.exports = __webpack_public_path__ + "static/media/telefonia_valida.4d5adbc8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/ValidandoTelefonia/telefonia_valida.svg
// module id = 1852
// module chunks = 0